module.exports = "https://static.wanderu.com/static/media/ie.1b0ac4e7.svg";